<template >
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row mt-5">
          <div class="form-group">
            <div class="form-label-group pl-5 pt-1">
              <div class="dropdown ml-3">
                <button
                  class="btn green-color dropdown-toggle"
                  type="button"
                  id="dropdownMenuButtonSearch"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {{ dropDownUserTypeName }}
                </button>
                <div
                  class="dropdown-menu"
                  aria-labelledby="dropdownMenuButtonSearch"
                  style="max-height: 400px; overflow: hidden auto"
                >
                  <a
                    class="dropdown-item pointer"
                    v-for="item in userTypeArray"
                    :key="item.id"
                    @click="dropDownUserTypeClick(item.name, item.id)"
                    >{{ item.name }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="no-more-tables">
      <table
        class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
      >
        <thead class="cf" style="border-style: none">
          <tr>
            <th class="numeric">მობილური</th>
            <th class="numeric">Email</th>
            <th class="numeric">დივაისი</th>
            <th class="numeric">პირადი ნომერი</th>
            <th class="numeric">შექმნის თარიღი</th>
            <th class="numeric">სტატუსი</th>
            <th class="numeric">ლარი</th>
            <th class="numeric">ქულა</th>
            <th class="numeric">ანგარიშის ნომერი</th>
            <th class="numeric">მომხმარებლის წაშლა</th>
            <th class="numeric">ოპერაციების წაშლა</th>
            <th class="numeric">ქულები</th>
          </tr>
        </thead>
        <tbody>
          <tr class="heading" v-for="value in array" :key="value.id">
            <td data-title="მობილური" class="numeric">
              {{ value.phone }}
            </td>
            <td data-title="Email" class="numeric">{{ value.email }}</td>
            <td data-title="Device" class="numeric">{{ value.device }}</td>
            <td data-title="Device" class="numeric">{{ value.identity }}</td>
            <td data-title="შექმნის თარიღი" class="numeric">
              {{ value.created }}
            </td>
            <td data-title="სტატუსი" class="numeric">
              <input
                type="checkbox"
                class="form-check-input"
                style="margin-left: 0px"
                id="id1"
                v-model="value.locked"
              />
            </td>
            <td data-title="Amount" class="numeric">{{ value.amount }}</td>
            <td data-title="Point" class="numeric">{{ value.point }}</td>
            <td data-title="AccountNumber" class="numeric">
              {{ value.accountNumber }}
            </td>
            <td data-title="მომხმარებლის წაშლა" class="numeric">
              <div>
                <i
                  class="fas fa-trash fa-fw deleteBtn"
                  title="მომხმარებლის წაშლა"
                  data-toggle="modal"
                  data-target="#exampleModalLongDelete"
                  data-backdrop="static"
                  data-keyboard="false"
                  @click="deleteAccount(value.id)"
                ></i>
              </div>
            </td>
            <td data-title="ოპერაციების წაშლა" class="numeric">
              <div>
                <i
                  class="fas fa-trash fa-fw deleteBtn"
                  title="ოპერაციების წაშლა"
                  data-toggle="modal"
                  data-target="#exampleModalLongDelete"
                  data-backdrop="static"
                  data-keyboard="false"
                  @click="deleteAccountOperations(value.id)"
                ></i>
              </div>
            </td>
            <td data-title="ქულები" class="numeric">
              <div>
                <i
                  class="fa fa-pencil-alt fa-fw editBtn"
                  title="ქულები"
                  data-toggle="modal"
                  data-target="#exampleModalLongEdit"
                  data-backdrop="static"
                  data-keyboard="false"
                  @click="editPoints(value.id)"
                ></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLongEdit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header pastel-green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              ქულების რედაქტირება
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              ჯამური ქულა - {{ this.totalBalance }} <br />
              ჯამური ბლოკი - {{ this.totalBlock }} <br />
              ჯამური ვალი - {{ this.totalDebt }}
            </div>
            <div id="no-more-tables">
              <table
                class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
              >
                <thead class="cf" style="border-style: none">
                  <tr>
                    <th class="numeric">სახელი</th>
                    <th class="numeric">ქულები</th>
                    <th class="numeric">დაბლოკილი ქულები</th>
                    <th class="numeric">ქულები</th>
                    <th class="numeric">ქულის დამატება</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="heading"
                    v-for="value in userPoints"
                    :key="value.id"
                  >
                    <td data-title="სახელი" class="numeric">
                      {{ value.name }}
                    </td>
                    <td data-title="ქულები" class="numeric">
                      {{ value.balance }}
                    </td>
                    <td data-title="დაბლოკილი ქულები" class="numeric">
                      {{ value.blockedAmount }}
                    </td>
                    <td data-title="ქულები" class="numeric">
                      <input type="text" v-model="pointsToAdd1" />
                    </td>
                    <td data-title="ქულის დამატება" class="numeric">
                      <div>
                        <i
                          class="fa fa-plus-circle addNewBtn mt-1 ml-4"
                          title="ქულის დამატება"
                          data-toggle="modal"
                          data-target="#exampleModalAddPoints"
                          data-backdrop="static"
                          data-keyboard="false"
                          @click="
                            addPoints(
                              value.partnerId,
                              pointsToAdd1,
                              value.partnerCustomerId,
                              value.userId
                            )
                          "
                        ></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "cashierLoyalty",
  data() {
    return {
      array: "",
      userTypeArray: [],
      dropDownUserTypeName: "მარტივი რეგისტრაცია",
      isAnonymous: null,
      userPoints: [],
      pointsToAdd: null,
      totalBalance: null,
      totalBlock: null,
      totalDebt: null,
    };
  },

  async created() {
    this.userTypeArray.push({ id: 1, name: "მარტივი რეგისტრაცია" });
    this.userTypeArray.push({ id: 2, name: "არასრული რეგისტრაცია" });

    this.dropDownUserTypeName = "მარტივი რეგისტრაცია";
    this.isAnonymous = false;
    let result = await this.$http.getAppAccounts({
      isAnonymous: this.isAnonymous,
    });
    this.array = result.data.res;
  },
  methods: {
    async deleteAccount(value) {
      //ახლის დამატება
      try {
        let result = await this.$http.deleteAppAccounts({ id: value });

        if (result.data.resultCode === "200") {
          bus.$emit("success", "მომხმარებელი წარმატებით წაიშალა");

          let result = await this.$http.getAppAccounts({
            isAnonymous: this.isAnonymous,
          });
          this.array = result.data.res;
        } else {
          bus.$emit("warning", "მომხმარებლის წაშლის დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async deleteAccountOperations(value) {
      //ახლის დამატება
      try {
        let result = await this.$http.deleteUserOperations({ userId: value });

        if (result.data.status === "200") {
          bus.$emit("success", "ოპერაციები წარმატებით წაიშალა");

          let result = await this.$http.getAppAccounts({
            isAnonymous: this.isAnonymous,
          });
          this.array = result.data.res;
        } else {
          bus.$emit("warning", "ოპერაციების წაშლის დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async addPoints(partnerId, points, partnerCustomerId, userId) {
      //ახლის დამატება
      try {
        let result = await this.$http.addPoints({
          partnerId: partnerId,
          points: points,
          partnerCustomerId: partnerCustomerId,
        });
        if (result.data.status == "200") {
          bus.$emit("success", "წარმატებით დაემატა");

          this.editPoints(userId);
          this.pointsToAdd1 = null;
          //let result = await this.$http.getAppAccounts({
          //isAnonymous: this.isAnonymous,
          //});
          //this.array = result.data.res;
        } else {
          bus.$emit("warning", "დაფიქსირდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async getUserPoints1(value) {
      let result = await this.$http.getUserPoints({ userId: value });
      this.userPoints = result.data;

      let totalResult = await this.$http.getUserTotalPoints({ userId: value });
      this.totalBalance = totalResult.data.totalBalance;
      this.totalBlock = totalResult.data.blockedAmount;
      this.totalDebt = totalResult.data.debtAmount;

      console.log(totalResult);
    },
    async editPoints(value) {
      this.userPoints = [];
      this.totalBalance = null;
      this.totalBlock = null;
      this.totalDebt = null;

      await this.getUserPoints1(value);
    },
    clearData() {
      this.cashierLoyalty.id = null;
      this.cashierLoyalty.name = "";
      this.cashierLoyalty.parameter1 = 18;
      this.cashierLoyalty.parameter2 = 20;
      this.cashierLoyalty.parameter3 = 1.34;
      this.cashierLoyalty.parameter4 = "";
      this.cashierLoyalty.status = false;
      this.cashierLoyalty.info = "";
      this.modalDescr = "სალაროს ლოიალობის პირობების დამატება";
    },
    async dropDownUserTypeClick(name, id) {
      this.dropDownUserTypeName = name;
      this.isAnonymous = id == 1 ? false : true;
      let result = await this.$http.getAppAccounts({
        isAnonymous: this.isAnonymous,
      });
      this.array = result.data.res;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";

.error-border {
  border-color: #ffb3b3;
  box-shadow: none;
}
.editBtn {
  margin-left: 10px;
  font-size: 30px;
  cursor: pointer;
  color: #52af8e;
}
.deleteBtn {
  font-size: 30px;
  cursor: pointer;
  color: #d43f3a;
  margin-left: 10px;
}

.searchBtn {
  font-size: 40px;
  margin-top: -5px;
  cursor: pointer;
  color: #489d7f;
}

.addNewBtn {
  font-size: 44px;
  margin-left: 15px;
  cursor: pointer;
  color: #52af8e;
  margin-top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/AppAccountManagement.vue